import { ChatUploadLabResultsCubit, Step } from "./ChatUploadLabResultsCubit";
import { FC, useEffect } from "react";
import { UnsupportedFormatScreen } from "./screens/UnsupportedFormatScreen";
import { ProviderSelectionScreen } from "./screens/ProviderSelectionScreen";
import { HowToGetReportScreen } from "./screens/HowToGetReportScreen";
import { PdfInfoScreen } from "./screens/PdfInfoScreen";
import { FinalScreen } from "./screens/FinalScreen";
import { LabReportUploadRequest } from "@9amhealth/openapi";
import { useBlocNext } from "@blac/react";
import { IconHeartInHands, PlanPendingIcon } from "src/constants/icons";

interface UploadLabResultStepContentProps {
  closeDialog: () => void;
  isUploading: boolean;
  uploadFilesAndShowStep: (
    step: Step,
    provider?: LabReportUploadRequest["provider"]
  ) => Promise<void>;
}

export const UploadLabResultStepContent: FC<
  UploadLabResultStepContentProps
> = ({ closeDialog, isUploading, uploadFilesAndShowStep }) => {
  const [{ currentStep }, { setProviderChoice }] = useBlocNext(
    ChatUploadLabResultsCubit
  );

  useEffect(() => {
    if (currentStep === "providerSelection") {
      setProviderChoice(null);
    }
  }, [currentStep]);

  if (currentStep === "unsupportedFormat") {
    return <UnsupportedFormatScreen />;
  }

  if (currentStep === "providerSelection") {
    return (
      <ProviderSelectionScreen
        uploadFilesAndShowStep={uploadFilesAndShowStep}
      />
    );
  }

  if (currentStep === "howToGetReport") {
    return (
      <HowToGetReportScreen
        isUploading={isUploading}
        uploadFilesAndShowStep={uploadFilesAndShowStep}
      />
    );
  }

  if (currentStep === "pdfInfo") {
    return <PdfInfoScreen isUploading={isUploading} />;
  }

  if (currentStep === "almostThere") {
    return (
      <FinalScreen
        titleKey="chat.labUpload.almostThere.title"
        descriptionKey="chat.labUpload.almostThere.description"
        buttonKey="chat.labUpload.almostThere.button"
        buttonAction={closeDialog}
        icon={<PlanPendingIcon />}
      />
    );
  }

  if (currentStep === "goodNews") {
    return (
      <FinalScreen
        titleKey="chat.labUpload.goodNews.title"
        descriptionKey="chat.labUpload.goodNews.description"
        buttonKey="chat.labUpload.goodNews.button"
        buttonAction={closeDialog}
        icon={<PlanPendingIcon />}
      />
    );
  }

  if (currentStep === "willHelpYou") {
    return (
      <FinalScreen
        titleKey="chat.labUpload.willHelpYou.title"
        descriptionKey="chat.labUpload.willHelpYou.description"
        buttonKey="chat.labUpload.willHelpYou.button"
        buttonAction={closeDialog}
        icon={<IconHeartInHands width={64} height={64} />}
      />
    );
  }

  return null;
};
